import { UserToolSet } from "@cohesive/api-client";

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Return the connected tool sets whose `cli_name` appears as a whole word in the
 * command — mirroring neuraflow-python's cliregistry/detect.py — so the UI can
 * surface which connectors a proposed terminal command touches. Deduped by tool
 * set id, preserving input order.
 */
export function detectClisInCommand(
  command: string,
  toolSets: UserToolSet[],
): UserToolSet[] {
  if (!command) return [];
  const seen = new Set<string>();
  const matched: UserToolSet[] = [];
  for (const ts of toolSets) {
    if (!ts.cli_name || seen.has(ts.id)) continue;
    if (new RegExp(`\\b${escapeRegExp(ts.cli_name)}\\b`).test(command)) {
      seen.add(ts.id);
      matched.push(ts);
    }
  }
  return matched;
}
